export default __webpack_public_path__ + "static/media/gallery_02.927b3cf1.jpg";